<span
  [ngClass]="getClassName()"
  [ngStyle]="getStyles()"
  id="shared-text-component-container"
>
  <ng-container *ngTemplateOutlet="tempOutlet"></ng-container>
</span>

<ng-template #tempOutlet>
  <ng-content></ng-content>
</ng-template>
